<template>
  <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('on-close-modal')">
    <i class="yapla-icon icon-close"></i>
  </button>
</template>

<script>
export default {
  name: "AppButtonCloseModal",
};
</script>
